import React, { useEffect, useState } from 'react';
import './PvWrapper.css';
import TopPanel from "./TopPanel";
import PvWebcam from "./PvWebcam";
import PvWebcamOverlay from "./PvWebcamOverlay";
import { useTranslation } from "react-i18next";
import FaceRotrationArrow from './FaceRotrationArrow';

export default function PvWrapper(props) {
    const { t } = useTranslation();
    const [displayContinueButton, setDisplayContinueButton] = useState(false);
    const [displayExitButton, setDisplayExitButton] = useState(false);
    const [displaySoundMeter, setDisplaySoundMeter] = useState(false);
    const [faceSvgAccepted, setFaceSvgAccepted] = useState(true);
    const [displayFaceSvg, setDisplayFaceSvg] = useState(true);
    const [displayVideoInstruction, setDisplayVideoInstruction] = useState(false);
    const [videoInstructionId, setVideoInstructionId] = useState(11);
    const [displayDocumentMask, setDisplayDocumentMask] = useState(false);
    const [documentMaskAccepted, setDocumentMaskAccepted] = useState(false);
    const [documentMaskHeightToWidthRatio, setDocumentMaskHeightToWidthRatio] = useState(0.63);
    const [displayFaceRotationArrow, setDisplayFaceRotationArrow] = useState(false);
    const [displayExitScreen, setDisplayExitScreen] = useState(false);
    const [videoWidth, setVideoWidth] = useState(640);
    const [videoHeight, setVideoHeight] = useState(480);
    const [displayLoadingIcon, setDisplayLoadingIcon] = useState(true);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [stream, setStream] = useState(null);
    const [userInfo, setUserInfo] = useState(t("Przygotuj się do wideoweryfikacji"));
    const [buttonText, setButtonText] = useState("Start");
    const [isButtonDisplayed, setIsButtonDisplayed] = useState(false);
    const [stepId, setStepId] = useState(1);
    const [faceRotrationArrowDirectionRight, setFaceRotrationArrowDirectionRight] = useState(false);
    const devMode = false;
    const timeoutFace = devMode ? 100 : 5000;
    const timeoutNameSurname = devMode ? 100 : 7000;
    const timeoutDocument = devMode ? 100 : 15000;
    


    useEffect(() => {
        handleButtonClickHeadStraight();
    }, []);

    const handleVideoWidthChange = (newVideoWidth) => {
        setVideoWidth(newVideoWidth)
    }

    const handleVideoHeightChange = (newVideoHeight) => {
        setVideoHeight(newVideoHeight)
    }

    const handleButtonClickHeadStraight = () => {
        setUserInfo(t("Ustaw głowę na wprost"));
        setIsButtonDisplayed(false);
        setTimeout(() => {
            setUserInfo(t("Jeżeli już popatrzyłeś na wprost, kliknij przycisk dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(1);
        }, timeoutFace);
    }

    const handleButtonClickHeadLeft = () => {
        setUserInfo(t("Obróć głowę lekko w lewo"));
        setIsButtonDisplayed(false);
        setDisplayFaceRotationArrow(true);
        setFaceRotrationArrowDirectionRight(false);
        setTimeout(() => {
            setUserInfo(t("Jeżeli już popatrzyłeś na lewo, kliknij przycisk dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(2);
        }, timeoutFace);
    }

    const handleButtonClickHeadRight = () => {
        setUserInfo(t("Obróć głowę lekko w prawo"));
        setIsButtonDisplayed(false);
        setDisplayFaceRotationArrow(true);
        setFaceRotrationArrowDirectionRight(true);
        setTimeout(() => {
            setUserInfo(t("Jeżeli już popatrzyłeś na prawo, kliknij przycisk dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(3);
        }, timeoutFace);
    }

    const handleButtonClickNameSurname = () => {
        setUserInfo(t("Wyraźnie wypowiedz imię i nazwisko"));
        setIsButtonDisplayed(false);
        setDisplayFaceSvg(false);
        setDisplayFaceRotationArrow(false);
        setTimeout(() => {
            setUserInfo(t("Po wyraźnym wypowiedzeniu imienia i nazwiska naciśnij dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(4);
        }, timeoutNameSurname);
    }

    const handleButtonClickDocumentFront = () => {
        setUserInfo(t("Pokaż dokument: awers dowodu osobistego lub okładkę paszportu"));
        setIsButtonDisplayed(false);
        setDisplayDocumentMask(true);
        setTimeout(() => {
            setUserInfo(t("Jeżeli już pokazałeś awers lub okładkę dokumentu to kliknij przycisk dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(5);
        }, timeoutDocument);
    }

    const handleButtonClickDocumentBack = () => {
        setUserInfo(t("Pokaż dokument: rewers dowodu osobistego lub stronę paszportu ze zdjęciem"));
        setIsButtonDisplayed(false);
        setDisplayDocumentMask(true);
        setTimeout(() => {
            setUserInfo(t("Jeżeli już pokazałeś rewers lub stronę ze zdjęciem dokumentu to kliknij przycisk dalej"));
            setButtonText(t("Dalej"));
            setIsButtonDisplayed(true);
            setStepId(6);
        }, timeoutDocument);
    }

    const handleButtonClickFinish = () => {
        setUserInfo(t("Koniec"));
        setIsButtonDisplayed(false);
        mediaRecorder.stop();
    }

    const handleButtonClickLsit = [
        handleButtonClickHeadStraight,
        handleButtonClickHeadLeft,
        handleButtonClickHeadRight,
        handleButtonClickNameSurname,
        handleButtonClickDocumentFront,
        handleButtonClickDocumentBack,
        handleButtonClickFinish
    ]

    const handleExitButtonClick = () => {
        mediaRecorder.stop();
    }

    const handleRecordingStarted = () => {
        setDisplayLoadingIcon(false)
    }

    return (
        <div className="PvWrapper" >
            <div className="PvWebcamWrapper">
                <PvWebcam
                    mediaRecorder={mediaRecorder}
                    setMediaRecorder={setMediaRecorder}
                    handleDisplayExitScreen={props.handleDisplayExitScreen}
                    handleRecordingStarted={handleRecordingStarted}
                    handleUserMediaError={props.handleUserMediaError}
                    setStream={setStream}
                    stream={stream}
                    setDisplayLoadingScreenState={props.setDisplayLoadingScreenState}
                    handleServerError={props.handleServerError}
                    handleVideoHeightChange={handleVideoHeightChange}
                    handleVideoWidthChange={handleVideoWidthChange}
                    PvApiUrl={props.PvApiUrl}
                />
                <PvWebcamOverlay
                    DISPLAY_FACE_SVG={displayFaceSvg}
                    FACE_SVG_ACCEPTED={faceSvgAccepted}
                    DISPLAY_DOCUMENT_MASK={displayDocumentMask}
                    DOCUMENT_MASK_ACCEPTED={documentMaskAccepted}
                    DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO={documentMaskHeightToWidthRatio}
                    videoWidth={videoWidth}
                    videoHeight={videoHeight} 
                />
                <PvWebcamOverlay
                    DISPLAY_FACE_ROTATION_ARROW={displayFaceRotationArrow}
                    faceRotrationArrowDirectionRight={faceRotrationArrowDirectionRight}
                    videoWidth={videoWidth}
                    videoHeight={videoHeight}
                />
                <TopPanel
                    infoBoxMessage={userInfo}
                    DISPLAY_CONTINUE_BUTTON={displayContinueButton}
                    DISPLAY_EXIT_BUTTON={displayExitButton}
                    DISPLAY_SOUND_METER={displaySoundMeter}
                    DISPLAY_VIDEO_INSTRUCTION={displayVideoInstruction}
                    VIDEO_INSTRUCTION_ID={videoInstructionId}
                    stream={stream}
                    handleExitButtonClick={handleExitButtonClick}
                    displayLoadingIcon={displayLoadingIcon}
                    buttonText={buttonText}
                    isButtonDisplayed={isButtonDisplayed}
                    stepId={stepId}
                    handleButtonClick={handleButtonClickLsit[stepId]}
                />
            </div>
        </div>
    );
}
